import { render, staticRenderFns } from "./PublicsNewsTable.vue?vue&type=template&id=43e8d342"
import script from "./PublicsNewsTable.vue?vue&type=script&lang=js"
export * from "./PublicsNewsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports